import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconNames } from '../../constants';

@Component({
  selector: 'ui-cross-icon',
  template: `<ui-svg-icon [name]="iconNames.Close" class="tw-text-red-600 tw-align-middle"></ui-svg-icon>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrossIconComponent {
  iconNames = IconNames;
}
